// Vendors
import styled from 'styled-components';

const LandingOptionsModalFeaturesComponentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: calc(${({ theme }) => theme.spacing_150} + ${({ theme }) => theme.spacing_250});
  width: 100%;
`;
LandingOptionsModalFeaturesComponentStyled.displayName =
  'LandingOptionsModalFeaturesComponentStyled';

const LandingOptionsModalFeaturesListComponentStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_300};
  width: 100%;
`;
LandingOptionsModalFeaturesListComponentStyled.displayName =
  'LandingOptionsModalFeaturesListComponentStyled';

const LandingOptionsModalFeaturesItemComponentStyled = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing_200};
  margin: 0;
  padding: 0;
  list-style: none;
`;
LandingOptionsModalFeaturesItemComponentStyled.displayName =
  'LandingOptionsModalFeaturesItemComponentStyled';

export {
  LandingOptionsModalFeaturesComponentStyled,
  LandingOptionsModalFeaturesListComponentStyled,
  LandingOptionsModalFeaturesItemComponentStyled,
};
